<template>
  <div>
    <v-select
        v-bind="$attrs"
        dense outlined chips deletable-chips
        v-model="valueList"
        :items="items"
    >
      <template v-slot:selection="{ item }">
        <v-chip
            small
            :color="item.color"
            @click:close="deleteChip(item)"
        >
          {{ item.text }}
        </v-chip>
      </template>
    </v-select>

  </div>
</template>

<script>

export default {
  name: 'BaseColorSelectedField',
  props: ['value', 'items'],

  methods: {
    deleteChip(itemToRemove) {
      if (this.valueList.constructor.name === "Array")
        this.valueList = this.valueList.filter(item => item !== itemToRemove.text)
      else
        this.valueList = null
    },
  },
  computed: {
        valueList: {
            get: function() {
                return this.value
            },
            set: function(value) {
                this.$emit('input', value)
                this.$emit('change', value)
            }
        }
    },
}
</script>

<style scoped lang="scss">
</style>
